var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGallery333(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 19,
    rx: 4.5,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval 6",
    cx: 7.46087,
    cy: 5.5,
    rx: 1.46087,
    ry: 1.5,
    stroke: "#333333",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    d: "M15.001 8C13.001 8 12.001 11 10.501 11C9.001 11 9.002 10 7.001 10C5.001 10 4 14 4 14H18.001C18.001 14 17.001 8 15.001 8",
    stroke: "#333333",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery333);
export default __webpack_public_path__ + "static/media/icGallery333.9e68132b4e589775b483ef14a9f81a68.svg";
export { ForwardRef as ReactComponent };